// src/pages/CustomerList.jsx

import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from '../../axios';
import API_BASE_URL from '../../config';
import { Button } from '../../components/ui/button';
import { Card, CardContent } from '../../components/ui/card';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

export default function CustomerList() {
  const navigate  = useNavigate();
  const companyId = localStorage.getItem('companyId');
  const [customers, setCustomers] = useState([]);

  useEffect(() => {
    if (!companyId) return;
    axios.get(`/Customer/by-company/${companyId}`)
      .then(res => setCustomers(res.data))
      .catch(err => console.error('❌ Error loading customers:', err));
  }, [companyId]);

  const deleteCustomer = id => {
    if (!window.confirm('❗ تأكيد الحذف')) return;
    axios.delete(`${API_BASE_URL}/Customer/${id}`)
      .then(() => {
        setCustomers(cs => cs.filter(c => c.id !== id));
        alert('🗑️ تم حذف العميل');
      })
      .catch(err => {
        console.error('❌ Error deleting customer:', err);
        alert('❌ حدث خطأ أثناء الحذف');
      });
  };

  const exportToExcel = () => {
    const data = customers.map((c, idx) => ({
      'رقم': idx + 1,
      'الاسم': c.name,
      'الرقم الضريبي': c.taxNumber || '-',
      'الجوال': c.mobile || '-'
    }));
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'العملاء');
    const wbout = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([wbout], { type: 'application/octet-stream' });
    saveAs(blob, `customers_${new Date().toISOString().slice(0,10)}.xlsx`);
  };

  return (
    <Card className="p-6" dir="rtl">
      <CardContent>
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-bold">📋 قائمة العملاء</h2>
          <div className="flex gap-2">
            <Button onClick={exportToExcel}>📥 تصدير Excel</Button>
            <Button onClick={() => navigate('/customers/new')}>➕ إضافة عميل</Button>
          </div>
        </div>

        <div className="overflow-x-auto">
          <table className="w-full table-auto border-collapse text-sm">
            <thead>
              <tr className="bg-gray-100">
                {['#','الاسم','الرقم الضريبي','الجوال','إجراءات'].map((h, i) => (
                  <th key={i} className="px-4 py-2 border text-center">{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {customers.map((c, idx) => (
                <tr key={c.id} className={idx % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                  <td className="px-4 py-2 border text-center">{idx + 1}</td>
                  <td className="px-4 py-2 border">{c.name}</td>
                  <td className="px-4 py-2 border text-center">{c.taxNumber || '-'}</td>
                  <td className="px-4 py-2 border text-center">{c.mobile || '-'}</td>
                  <td className="px-4 py-2 border text-center space-x-2">
                    <Button
                      size="sm"
                      variant="outline"
                      onClick={() => navigate(`/customers/${c.id}/edit`)}
                    >
                      ✏️
                    </Button>
                    <Button
                      size="sm"
                      variant="destructive"
                      onClick={() => deleteCustomer(c.id)}
                    >
                      🗑️
                    </Button>
                  </td>
                </tr>
              ))}
              {customers.length === 0 && (
                <tr>
                  <td colSpan={5} className="px-4 py-6 border text-center text-gray-500">
                    لا يوجد عملاء
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </CardContent>
    </Card>
  );
}
